export default __webpack_public_path__ + "static/media/TheShadowOfThePyramid.a9c524ec.jpg";